import { LoadingSpinner } from "./LoadingSpinner";

type ScopedLoadingSpinnerProps = {
  surface?: string;
};

// Form/card-scoped loading overlay. Same backdrop + spinner UX as
// CoveringLoadingSpinner, but `absolute inset-0` so it covers only its
// positioned-parent's box, not the AppBar / sidebar. Parent must have
// `position: relative` for `inset-0` to resolve against it.
export const ScopedLoadingSpinner: React.FC<ScopedLoadingSpinnerProps> = ({
  surface = "surface-primary opacity-50",
}) => {
  return (
    <div
      className={`absolute inset-0 ${surface} flex items-center justify-center z-40 pointer-events-auto`}
    >
      <LoadingSpinner />
    </div>
  );
};
